// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/section/burger/burger-top-desktop.scss
 ** module id = 42
 ** module chunks = 0 1
 **/